import parsePhoneNumberFromString, { isValidPhoneNumber } from 'libphonenumber-js';
import * as Yup from 'yup';

import { isValidAddress, isValidEmail, isValidName, isValidZipCode } from '../../../../Utils/validation';

export const profileValidationSchema = (reviewProfile = false): any => {
  return Yup.object().shape({
    profile_img: Yup.string(),
    first_name: Yup.string()
      .required('First name is required')
      .test('test-name', 'Enter Valid First Name', (value: any) => {
        if (value && !isValidName(value)) {
          return false;
        }
        return true;
      }),
    middle_name: Yup.string().test('test-name', 'Enter Valid Middle Name', (value: any) => {
      if (value && !isValidName(value)) {
        return false;
      }
      return true;
    }),
    last_name: Yup.string()
      .required('Last name is required')
      .test('test-name', 'Enter Valid Last Name', (value: any) => {
        if (value && !isValidName(value)) {
          return false;
        }
        return true;
      }),
    address1: Yup.string()
      .required('Address is required')
      .test('test-adress1', 'Valid Address is required', (value: any) => {
        return isValidAddress(value);
      }),
    address2: Yup.string(),
    city: Yup.string().required('City is required'),
    state: Yup.string().required('State is required'),
    zip_code: Yup.string()
      .required('Zip Code is required')
      .test('test-zipcode', 'Valid Zip Code is required', (value: any) => {
        return isValidZipCode(value);
      }),

    email: Yup.string()
      .required('Email is required')
      .test('test-email', 'Enter Valid Email', (value: any) => {
        return isValidEmail(value);
      }),
    client_tag_ids: reviewProfile
      ? Yup.array()
          .transform((value, originalValue) => {
            if (Array.isArray(originalValue)) return originalValue;
            if (!originalValue || originalValue === '') return [];
            if (typeof originalValue === 'object') return [originalValue];
            return originalValue;
          })
          .min(1, 'Select a client tag')
          .max(1, 'Only one client tag can be selected')
          .required('Select a client tag')
      : // Own-profile editing doesn't render the client-tag picker, but the form
        // still carries the assigned ids as an array of strings. Validating it
        // as an object casts that array to null and fails the whole submit.
        Yup.array().of(Yup.string()),
    phone_number: Yup.string().test('valid-us-phone', 'Enter Valid Phone Number', (value) => {
      // Optional → empty is allowed
      if (!value) return true;

      const phoneNumber = parsePhoneNumberFromString(value, 'US');

      return phoneNumber?.isValid() ?? false;
    }),
  });
};
